import { __awaiter } from "tslib";
import { callService } from "@phoenixreisen/gateway";
import DT from "date-and-time";
export function getCustomer(customernr, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        return callService("buchung-repo.get-kundendaten", {
            "remote-addr": "set by backend",
            "kunden-nr": parseInt(customernr, 10),
            jwt: jwt.toString(),
        });
    });
}
export function changeCustomer(data, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        return callService("rpc.meinphoenixservices.kundendaten", {
            "werbung-per-mail": data["kundendaten/werbung-per-mail"],
            "katalog-orient": data["kundendaten/katalog-orient"],
            "katalog-fluss": data["kundendaten/katalog-fluss"],
            "katalog-see": data["kundendaten/katalog-see"],
            "kunden-nr": data["kundendaten/kunden-nr"],
            journal: data["kundendaten/journal"],
            type: "katalogdaten-aendern",
            "remote-addr": "remote-addr",
            jwt: jwt,
        });
    });
}
export function getShips(kind, ships) {
    return __awaiter(this, void 0, void 0, function* () {
        if (ships) {
            return Promise.resolve(ships);
        }
        return callService("get-schiffe-mit-kabinenpraesenten", {
            typ: kind,
        });
    });
}
export function getCruises(ship, cruises) {
    return __awaiter(this, void 0, void 0, function* () {
        if (cruises) {
            return Promise.resolve(cruises);
        }
        return callService("get-routen", {
            schiff: ship,
        });
    });
}
export function getBooking(jwt_1, rechnr_1) {
    return __awaiter(this, arguments, void 0, function* (jwt, rechnr, size = "XL") {
        return callService("buchung-repo.extern-get-buchung", {
            "rech-nr": parseInt(rechnr, 10),
            size: size,
            jwt: jwt,
        });
    });
}
export function hasBeenReversed(booking) {
    var _a;
    const storno = (_a = booking["buchung/storno-datum"]) !== null && _a !== void 0 ? _a : null;
    return (storno && DT.parse(storno, "DD.MM.YYYY HH:mm")) || null;
}
export function hasCanceledFlag(booking) {
    return !!booking["buchung/reise-abgesagt?"];
}
export function alreadyCruised(booking) {
    var _a;
    const range = (_a = booking["buchung/reisezeitraum"]) !== null && _a !== void 0 ? _a : null;
    if (range) {
        const till = DT.addDays(DT.parse(range[1], "DD.MM.YYYY"), 1);
        const now = DT.parse(booking["buchung/buchungsstand"], "DD.MM.YYYY HH:mm");
        return till <= now;
    }
    return false;
}
export function alreadyStarted(booking) {
    var _a;
    const range = (_a = booking["buchung/reisezeitraum"]) !== null && _a !== void 0 ? _a : null;
    if (range) {
        const from = DT.parse(range[0], "DD.MM.YYYY");
        const now = DT.parse(booking["buchung/buchungsstand"], "DD.MM.YYYY HH:mm");
        return now >= from;
    }
    return false;
}
